import { isExternalLink } from '@/helpers/isExternalLink';
import { nanoid } from 'nanoid';

interface MultiLinkFields {
    id: string;
    name: string;
    description: string;
    to: string;
}

const getLinkVariant = (to: string) => {
    if (isExternalLink(to)) {
        return 'Link-External' as const;
    }
    return 'Link-Internal' as const;
};

export function toCardRowAttachmentLink(nodes: MultiLinkFields[] | undefined) {
    if (!nodes) return [];
    return nodes.map((node) => ({
        variant: getLinkVariant(node.to),
        label: node.name,
        linkTarget: node.to,
        helpButtonText: node.description,
    }));
}

export function emptyLink() {
    const newId = nanoid();
    return {
        id: `new-${newId}`,
        name: '',
        to: '',
        description: '',
        status: 'create' as const,
    };
}
